const get = require('lodash/get')
const { prepareUserToSave } = require('./save')
const denormaliseUser = require('./../../../utils/denormalise-user')
const { listUsersByRoutes, get: getUser } = require('../read')

// Lightweight save for route-only updates: skips location/reporting-period
// validation and avoids the redundant get-before and get-after-save that
// the full update() path performs.
async function saveRouteForUser (state, user, routes, defaultRole) {
  const username = get(state.user, 'name')
  const userToSave = denormaliseUser(prepareUserToSave({ ...user, routes }, username), { defaultRole })
  await state.dal.user.saveOne(state, userToSave)
}

async function assignRoute (state, {driver, routeId, defaultRole}) {
  if (!routeId) {
    throw new Error(`routeId is required but was: ${routeId}`)
  }

  let routeIdToAssign = String(routeId).trim()
  if (!routeIdToAssign.startsWith('route:')) {
    routeIdToAssign = `route:${routeIdToAssign}`
  }

  let driverName = driver.name
  if (!driverName && driver._id) {
    const match = driver._id.match(/^org\.couchdb\.user:(.+)$/)
    driverName = match ? match[1] : driver._id
  }
  if (!driverName) {
    throw new Error('Driver name is required. Driver object must have either "name" or "_id" property.')
  }

  // Fetch previous driver and new driver in parallel - they are independent
  const [driversWithTheRoute, driverToAssign] = await Promise.all([
    listUsersByRoutes(state, {routes: [routeIdToAssign]}),
    getUser(state, driverName)
  ])

  const previousDriver = get(driversWithTheRoute, '0')

  await Promise.all([
    saveRouteForUser(state, driverToAssign, [routeIdToAssign], defaultRole),
    previousDriver
      ? saveRouteForUser(state, previousDriver, [], defaultRole)
      : Promise.resolve()
  ])
}
exports.assignRoute = assignRoute
